export default "__VITE_ASSET__EvJMe3C4__"